import { Injectable } from '@angular/core';
import { OutilAchatClientService } from '../../../../core/services/outil-achat-client.service';
import { Gamme, Otp } from './outil-achat.model';
import { map, Observable } from 'rxjs';
import { InlineResponse } from '../../../../core/models/inline-response.model';

@Injectable({
  providedIn: 'root'
})
export class ReferentialsOutilAchatService {

  constructor(private optClientService: OutilAchatClientService) {}

  getOptData(): Observable<Otp[]> {
    return this.optClientService.getOtp().pipe(
      map((opt) => opt.rows),
      map((rows) => rows.map((row) => new Otp(row.id, row.eotp, row.designation))),
    );
  }

  addOptData(eotp: string, libelle: string): Observable<InlineResponse> {
    return this.optClientService.addOpt(eotp, libelle);
  }

 updateOtpData(otp: Otp): Observable<InlineResponse> {
    return this.optClientService.updateOpt(otp);
  }

  getGammeData(): Observable<Gamme[]> {
    return this.optClientService.getGamme().pipe(
      map((opt) => opt.rows),
      map((rows) => rows.map((row) => new Gamme(row.id, row.designation))),
    );
  }

  addGammeData(libelle: string): Observable<InlineResponse> {
    return this.optClientService.addGamme(libelle);
  }

 updateGammeData(gamme: Gamme): Observable<InlineResponse> {
    return this.optClientService.updateGamme(gamme);
  }
}
